import * as _ from 'lodash';
import { CenterContactPosition } from "@nkr/enums/index";
import { IContact } from "@nkr/models/index";
import { ControlLabel, FormControl, FormGroup } from "react-bootstrap";

interface IProps {
    centerId: number,
    value: number,
    coordinators: IContact[],
    onChange: (e: any) => void;
}

const CoordinatorPicker = ({ value, centerId, onChange, coordinators }: IProps) => {
    const centerHasManager = coordinators.some(c => c.entityTypeId == centerId && c.positions.some(p => p.id == CenterContactPosition.KidneyMicrositeManager));

    const coordinatorsForOptions = _.sortBy(coordinators.filter(f => {
        const isManager = f.positions.some(p => p.id == CenterContactPosition.KidneyMicrositeManager);
        return f.entityTypeId == centerId && (!centerHasManager || isManager);
    }), x => x.fullName);

    return (
        <FormGroup >
            <ControlLabel>Coordinator <span style={{ color: 'darkred' }}>*</span></ControlLabel>
            <FormControl
                componentClass='select'
                value={value}
                onChange={onChange}
            >
                <option value={-1} disabled>- Select Coordinator -</option>
                {coordinatorsForOptions.map((c, i) =>
                    <option key={`coordinator-1-${i}`} value={c.id}>{c.fullName}</option>
                )}
            </FormControl>
        </FormGroup>
    );
}

export default CoordinatorPicker;